import { getMenuPermissions } from 'Helper/getMenuPermissions';
import Tooltip from 'UiKit/tooltip';
import { TextRegular } from 'UiKit/typography';

import ActionButton from 'View/live-account/component/action-button';
import getBrandText from 'View/live-account/helper/getBrandText';

import styles from './styles.module.css';

const buildTableList = (t) => {
  const accessPermission = getMenuPermissions('master-data', 'account-livestream');

  const tableList = [
    {
      name: t('tableColumnAccountId'),
      key: 'name',
      sortKey: 'name',
      width: 200,
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnStoreName'),
      key: 'storeName',
      sortKey: 'storeName',
      width: 200,
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value || '-'}</TextRegular>,
    },
    {
      name: t('tableColumnBrand'),
      key: 'brand',
      width: 151,
      component: ({ value }) => {
        const brandText = getBrandText(value);

        return (
          <Tooltip label={brandText}>
            <TextRegular className={`${styles['column__text--brand']} ${styles['column__text--truncate']}`}>{brandText}</TextRegular>
          </Tooltip>
        );
      },
    },
    {
      name: t('tableColumnPlatform'),
      key: 'platform',
      sortKey: 'ecommerce.name',
      width: 200,
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnAccountType'),
      sortKey: 'accountType.name',
      key: 'accountType',
      width: 200,
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnParentAccount'),
      key: 'parentAccount',
      width: 200,
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value || '-'}</TextRegular>,
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: t('tableColumnAction'),
      key: 'name',
      width: 150,
      position: 'center',
      rightSticky: 0,
      component: ({ values }) => <ActionButton values={values} />,
    });
  }

  return tableList;
};

export default buildTableList;